'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getBreadcrumb = exports.getParentIds = exports.getAliases = exports.getCurrentChildrenDeep = exports.getCurrentChildren = exports.getSelectedIds = undefined;

var _reselect = require('reselect');

var _elementHelper = require('../../../common/elements/elementHelper');

var _boardSelector = require('../../element/board/boardSelector');

var _milanoteReselect = require('../../utils/milanoteReselect/milanoteReselect');

var _boardConstants = require('../../../common/boards/boardConstants');

var _elementConstants = require('../../../common/elements/elementConstants');

var _aliasConstants = require('../../../common/alias/aliasConstants');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// Utils


// Selectors


// Constants


var getSelectedIds = exports.getSelectedIds = (0, _reselect.createSelector)(function (state) {
    return state.get('app').get('selection');
}, function (selection) {
    return selection.get('ids');
});

var getCurrentChildren = exports.getCurrentChildren = (0, _reselect.createSelector)(function (state) {
    return state.get('elements');
}, function (state, props) {
    return props.currentBoardId;
}, function (elements, currentBoardId) {
    return (0, _elementHelper.getChildren)(elements, currentBoardId);
});

var getCurrentChildrenDeep = exports.getCurrentChildrenDeep = (0, _reselect.createSelector)(function (state) {
    return state.get('elements');
}, function (state, props) {
    return props.currentBoardId;
}, function (elements, currentBoardId) {
    return (0, _elementHelper.getChildrenDeep)(elements, currentBoardId);
});

var getAliases = exports.getAliases = function getAliases(elements, elementId) {
    return elements.filter(function (element) {
        return element.get('elementType') === _aliasConstants.ALIAS_TYPE && element.get('content').get('linkTo') === elementId;
    });
};

var getParentIds = exports.getParentIds = function getParentIds(elements, element) {
    var parentId = element.getIn(['location', 'parentId']);
    var parent = elements.get(parentId);

    if (!parent || !parent.get('location')) return null;

    // We have a skeleton parent so an alias must be this user's true parent
    if (parent.get('elementType') === _elementConstants.SKELETON_ELEMENT_TYPE) {
        var aliases = getAliases(elements, element.get('id'));
        return aliases.toArray().map(function (alias) {
            return alias.get('id');
        });
    }

    return [parentId];
};

/**
 * Remove columns from the breadcrumb list
 */
var filterOutColumns = function filterOutColumns(elements) {
    return function (elementId) {
        var element = elements.get(elementId);
        return (0, _elementHelper.isBoard)(element) || (0, _elementHelper.isSkeleton)(element);
    };
};

var getBreadcrumb = exports.getBreadcrumb = (0, _reselect.createSelector)(function (state) {
    return state.get('elements');
}, function (state, props) {
    return props.currentBoardId;
}, function (state) {
    return state.getIn(['app', 'currentUser', 'rootBoardId']);
}, function (state) {
    return state.getIn(['app', 'currentUser', 'isGuest']);
}, function (elements, currentBoardId, rootBoardId, isGuest) {
    // Breadth first search until we find a the root element or we encounter a missing element
    var queue = [];
    var missingElementIds = [];
    var visitedElementIds = [];

    // Start at the current board and work backwards
    var elementId = currentBoardId;
    var currentPath = [elementId];

    var removeColumns = filterOutColumns(elements);

    while (elementId) {
        var element = elements.get(elementId);
        if (!element) return { complete: false, fullPath: currentPath, path: currentPath };

        if (elementId === rootBoardId) {
            // We've hit the root, so now filter out elements that aren't boards as we won't show these in our
            // breadcrumb
            var _filteredPath = currentPath.filter(removeColumns);
            var returnObj = { complete: true, fullPath: currentPath, path: _filteredPath };
            return returnObj;
        }

        // Get the potential parents
        // NOTE: If the alias has been deleted then this will return an empty array.  As a result it will pass
        // the next if statement and finish the while loop.  In this situation we have decided to handle this case
        // by using the default return statement at the bottom of this method to construct a breadcrumb including
        // only this element and the root element.  If this changes in the future we will need to revisit the
        // assumption here.
        var parentIds = getParentIds(elements, element);
        if (!parentIds) {
            missingElementIds.push(element.getIn(['location', 'parentId']));
            var _filteredPath2 = currentPath.filter(removeColumns);
            return { complete: false, missingElementIds: missingElementIds, fullPath: currentPath, path: _filteredPath2 };
        }

        visitedElementIds.push(elementId);
        /* eslint-disable no-loop-func */
        parentIds.forEach(function (parentId) {
            // If the parentId is already in the queue to be visited then don't add it again (this will effectively
            // drop the path from being searched as there is a quicker or just as quick path to root).
            if (queue.filter(function (queueEntry) {
                return queueEntry.elementId === parentId;
            }).length) return;

            var queueEntry = {
                elementId: parentId,
                currentPath: [parentId].concat(_toConsumableArray(currentPath))
            };
            queue.push(queueEntry);
        });
        /* eslint-enable no-loop-func */

        var nextQueueEntry = queue.shift();
        elementId = nextQueueEntry && nextQueueEntry.elementId;
        currentPath = nextQueueEntry ? nextQueueEntry.currentPath : currentPath;
    }

    // Will only arrive here if an alias has been deleted and there is no way back to root, so construct a fake
    // path consisting only of the shared board and the root board.
    var path = [].concat(_toConsumableArray(currentPath));
    var filteredPath = currentPath.filter(removeColumns);

    // Only add a root board ID if the user is not a guest user
    if (!isGuest) {
        filteredPath.unshift(rootBoardId);
        path.unshift(rootBoardId);
    }

    return { complete: true, fullPath: path, path: filteredPath };
});

var emptyState = {
    inboxElementIds: [],
    canvasElementIds: [],
    sortedCanvasElementIds: []
};

var inboxElementsSelector = (0, _milanoteReselect.createShallowSelector)(getCurrentChildren, function (children) {
    return (0, _elementHelper.getSortedChildrenInSection)(children, _boardConstants.BOARD_SECTIONS.INBOX, null, _elementHelper.sortByScore).map(function (el) {
        return el.get('id');
    }).toJS();
});

var canvasElementsSelector = (0, _reselect.createSelector)(getCurrentChildren, function (children) {
    return (0, _elementHelper.getSortedChildrenInSection)(children, _boardConstants.BOARD_SECTIONS.CANVAS, null, _elementHelper.sortByModified);
});

var sortedCanvasElementsSelector = (0, _milanoteReselect.createShallowSelector)(getSelectedIds, canvasElementsSelector, function (selectedIds, children) {
    return children.sort(function (elA, elB) {
        if ((0, _elementHelper.isElementLocked)(elA) && !(0, _elementHelper.isElementLocked)(elB)) return -1;
        if ((0, _elementHelper.isElementLocked)(elB) && !(0, _elementHelper.isElementLocked)(elA)) return 1;

        var elAisSelected = selectedIds.indexOf(elA.get('id')) !== -1;
        var elBisSelected = selectedIds.indexOf(elB.get('id')) !== -1;
        if (elAisSelected && !elBisSelected) return 1;
        if (elBisSelected && !elAisSelected) return -1;

        if ((0, _elementHelper.isLine)(elA)) return -1;
        if ((0, _elementHelper.isLine)(elB)) return 1;

        return 0;
    }).map(function (el) {
        return el.get('id');
    }).toJS();
});

exports.default = (0, _reselect.createSelector)(_boardSelector.getIsCurrentBoardFetched, inboxElementsSelector, sortedCanvasElementsSelector, canvasElementsSelector, function (currentBoardFetched, inboxElementIds, sortedCanvasElementIds, canvasElements) {
    if (!currentBoardFetched) return emptyState;

    // Sort canvasElementIds by their ID to prevent them from jumping around in the DOM when their ID changes.
    var canvasElementIds = canvasElements.map(function (el) {
        return el.get('id');
    }).toJS();

    return {
        inboxElementIds: inboxElementIds,
        canvasElementIds: canvasElementIds,
        sortedCanvasElementIds: sortedCanvasElementIds
    };
});


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/main/mainSelector.js
// module id = 239
// module chunks = 0